export default __webpack_public_path__ + "static/media/dev.567370bc.svg";